export default __webpack_public_path__ + "static/media/icon-google-w.ba05a9a0.svg";